module.exports = __webpack_public_path__ + "static/media/baseball.cd45f241.svg";